<template>
    <main class="contact-page">
        <!-- Header -->
        <ThemeHeader />

        <div id="shopify-section-contact" class="shopify-section">
            <ContactForm
                    :title="contactTitle"
                    :subtitle="contactstitle"
                    :subtitle2="contactstitle2"
                    :img="contactimg"
                    email="hello@readyjudy.com"
                    phonenum="+1 (888) 421-9926"
            />
        </div>

        <!-- Footer -->
        <div id="shopify-section-footer" class="shopify-section">
            <ThemeFooter />

            <!-- Footer Sale Box -->
            <FooterSaleBox />
        </div>
    </main>
</template>

<script>
    import ThemeHeader from "../components/common/ThemeHeader";
    import ContactForm from "../components/sections/ContactForm";
    import FooterSaleBox from "../components/common/FooterSaleBox";
    import ThemeFooter from "../components/common/ThemeFooter";
    export default {
        name: "Contact",
        components: {ThemeFooter, FooterSaleBox, ContactForm, ThemeHeader},
        data() {
            return {
                contactTitle: "WE'VE GOT \nYOU COVERED",
                contactstitle: 'Questions? Concerns?',
                contactstitle2: "We're looking forward to hearing from you.",
                contactimg: require('@/assets/images/contact.jpg')
            }
        }
    }
</script>

<style scoped>

</style>